<template>
    <div
        class="inline-flex items-center gap-0.5 rounded-xl bg-gray-100 p-1 ring-1 ring-inset ring-gray-200"
        role="group"
        aria-label="Language switcher"
    >
        <button
            v-for="locale in COOKIE_CONSENT_SERVICE_LOCALES"
            :key="locale"
            type="button"
            :aria-pressed="activeLocale === locale"
            :class="[
                'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold uppercase tracking-wide transition-all duration-200',
                activeLocale === locale
                    ? 'bg-white text-gray-800 shadow-sm ring-1 ring-inset ring-gray-200/60'
                    : 'text-gray-400 hover:text-gray-600',
            ]"
            @click="emit('update:activeLocale', locale)"
        >
            <span>{{ locale }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
import {
    COOKIE_CONSENT_SERVICE_LOCALES,
    type CookieConsentServiceLocale,
} from '@src/types'

withDefaults(
    defineProps<{
        activeLocale?: CookieConsentServiceLocale
    }>(),
    { activeLocale: COOKIE_CONSENT_SERVICE_LOCALES[0] }
)

const emit = defineEmits<{
    (e: 'update:activeLocale', value: CookieConsentServiceLocale): void
}>()
</script>
